import { useEffect, useState } from "react";
import "./CustomModal.css";

const EMPTY_OPTIONS = [];

const ConfirmationInputDialog = ({
  isOpen,
  toggle,
  caption,
  message,
  onConfirm,
  inputtype = "text",
  options = EMPTY_OPTIONS,
  defaultOption = "",
  inputPlaceholder = "",
  validate = null,
  confirmButtonText = "OK",
  cancelButtonText = "Cancel",
  disabled = false,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen) return;
    if (inputtype === "select" && options.length > 0) {
      setInputValue(defaultOption || options[0].value);
    } else {
      setInputValue("");
    }
    setError("");
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        toggle();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape, false);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape, false);
    };
  }, [isOpen, toggle]);

  const handleConfirm = () => {
    if (disabled) return;

    if (validate) {
      const validationError = validate(inputValue);
      if (validationError) {
        setError(validationError);
        return;
      }
    }

    onConfirm(inputValue);
    setInputValue("");
    setError("");
  };

  const handleInputChange = (event) => {
    event.stopPropagation();
    setInputValue(event.target.value);
    if (error) setError("");
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={toggle}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{caption}</h3>
          <button type="button" onClick={toggle} className="modal-close">
            &times;
          </button>
        </div>

        <div className="modal-body">
          {message && (
            <p className="modal-message" style={{ paddingBottom: "10px" }}>
              {message}
            </p>
          )}

          {inputtype === "select" ? (
            <select
              value={inputValue}
              onChange={handleInputChange}
              className="modal-select"
              disabled={disabled}
              autoFocus
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          ) : (
            <input
              type={inputtype}
              value={inputValue}
              placeholder={inputPlaceholder || message}
              onChange={handleInputChange}
              onInput={handleInputChange}
              onKeyDown={(event) => event.stopPropagation()}
              className="modal-input-box"
              disabled={disabled}
              autoFocus
            />
          )}

          {error && <div className="modal-error">{error}</div>}
        </div>

        <div className="model-footer-many">
          <button type="button" onClick={toggle} className="btn-cancel">
            {cancelButtonText}
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="btn-ok"
            disabled={!!error || disabled}
          >
            {confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationInputDialog;
